<template>
  <div class="card-block col p2 sans relative" :style="{ 'width': width + '%'}">
    <h3 v-if="header" class="fs-xs caps" v-html="header"></h3>
    <div v-if="type === 'exhibitionLinks'" class="content fs-s">
      <ul class="comma-list list-reset limit" :class="{ expanded: isExpanded }" v-if="content.length">
        <li v-for="(item, index) in content" :key="index">
          <router-link
            class="hover-red"
            :to="{ name: 'Exhibition', params: { slug: item.post_name }}">
            {{ item.post_title }}</router-link>
          <span class="expand-link pointer hover-red subdued" @click="isExpanded = true" v-if="index === 4 && content.length !== 5">({{ content.length - 5 }} more...)</span>
        </li>
      </ul>
      <span v-else>None</span>
    </div>
    <div v-else-if="type === 'location'" class="content fs-s">
      <span v-if="content.location_title">
        <router-link
          class="hover-red"
          :to="{ name: 'Investigation Location', params: { slug: content.investigation_location[0].slug }}">
          {{ content.location_title }}</router-link>
      </span>
      <span v-else>None</span>
    </div>
    <div v-else-if="type === 'methodologies'" class="content fs-s">
      <ul class="comma-list list-reset">
        <li v-for="item in content.acf.methodologies" :key="item.id">
          <router-link
            class="hover-red"
            :to="{ name: 'Investigation Methodology', params: { slug: item.post_name }}">
            {{ item.post_title }}</router-link>
        </li>
      </ul>
    </div>
    <div v-else-if="type === 'linkedOrg'" class="content fs-s">
      <ul v-if="content.length" class="comma-list list-reset">
        <li v-for="(item, index) in content" :key="index">
          <a v-if="item.fa_venue_link" :href="item.fa_venue_link" class="hover-red" target="_blank">{{ item.post_title }}</a>
          <span v-else>{{ item.post_title }}</span>
        </li>
      </ul>
      <span v-else>{{ ifEmpty }}</span>
    </div>
    <div v-else-if="type === 'no-header'" class="no-header content fs-s" v-html="contentProcessed"></div>
    <div v-else class="content fs-s" v-html="contentProcessed"></div>
    <div class="card-gradient absolute"></div>
  </div>
</template>

<script>
export default {

  name: 'CardBlock',

  data () {
    return {
      isExpanded: false
    }
  },

  props: ['width', 'header', 'content', 'type', 'if-empty'],

  computed: {
    contentProcessed: function () {
      if (this.content === "" ||
        this.content === false ||
        this.content === undefined) {
        return "None"
      } else {
        return this.content
      }
    }
  }
}
</script>

<style lang="css" scoped>
  .card-block {
    border-right: 1px solid var(--black);
    overflow-x: hidden;

    ul {
      margin-top: 0;
    }

    h3 {
      margin-bottom: 0.5em;
    }

    .content {
      min-height: 2.5em;
    }

    .no-header {
      margin-top: -3px;
    }

    &:last-child {
      border-right: none;
    }

    &:hover {
      max-height: auto;
      .card-gradient {
        display: none;
      }
    }
  }
</style>
